<template>
    <div class="flex justify-between">
        <sub-nav />
        <div>
            <p class="text-sm text-gray-700 leading-5">
                Showing
                <span class="font-medium" v-text="meta.from"></span>
                to
                <span class="font-medium" v-text="meta.to"></span>
                of
                <span class="font-medium" v-text="meta.total"></span>
                results
            </p>
        </div>
    </div>
    <div>
        <div class="flex gap-5">
            <input class="rounded" type="text" id="myInput" v-model="searchText" @input="userSearch()" placeholder="Search for names/email">
            <div class="pb-3">
                <select class="rounded border-gray-300" name="roleFilter" v-model="selectedRole" id="filter" @change="userSearch()">
                    <option value="" disabled selected>Select Role</option>
                    <option value="All">All</option>
                    <option value="TMA">TMA</option>
                    <option value="Distributor">Distributor</option>
                    <option value="Dealer">Dealer</option>
                    <option value="Agency">Agency</option>
                </select>
            </div>
            <div class="pb-3">
                <select class="rounded border-gray-300" name="statusFilter" v-model="selectedStatus" id="filter" @change="userSearch()">
                    <option value="" disabled selected>Select Status</option>
                    <option value="All">All</option>
                    <option value="Active">Active</option>
                    <option value="Pending">Pending</option>
                    <option value="Locked">Locked</option>
                    <option value="Rejected">Rejected</option>
                    <!-- <option value="Unknown">Unknown</option> -->
                </select>
            </div>
            <div class="pb-3">
                <select class=" border-gray-300" name="countryFilter" v-model="selectedCountry" id="filter" @change="userSearch()">
                    <option value="" disabled selected>Select Country</option>
                    <option value="All">All</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Brunei">Brunei</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Laos">Laos</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Vietnam">Vietnam</option>
                </select>
            </div>
            <div class="mb-3">
                <button class="bg-red-500 hover:bg-red-700 text-white py-2 px-4 font-bold rounded" @click="clearFilters">
                    Reset Filters
                </button>
            </div>
        </div>
        <div class="flex gap-5">
            <button :class="unlockClass(isEmpty)"  :disabled="isEmpty" @click="toggleModal('unlock')">
                Unlock Accounts
                {{
                    checkedUsers.length > 0 ? checkedUsers.length : ""
                }}
            </button>
        </div>
        <table id="myTable">
            <tr class="header">
                <th id="check"></th>
                <th id="sn">S/N</th>
                <th id="name">Name</th>
                <th id="email">Email</th>
                <th id="country">Country</th>
                <th id="role">Role</th>
                <th id="status">Account Status</th>
                <th id="action">Action</th>
            </tr>
            <tr v-for="user in users" :key='user.id'>
                <td>
                    <input v-if="user.is_locked" name="unlock" v-model="checkedUsers" :value="user.id" @change="unlockClass(isEmpty)" type="checkbox" class="rounded ml-2 mr-1 bg-gray-100">
                    <input v-else type="checkbox" class="rounded ml-2 mr-1 bg-gray-100 border-gray-300" disabled="">
                </td>
                <td>{{ user.id }}</td>
                <td>
                    {{ user.firstName + ' ' + user.lastName }}
                </td>
                <td>{{ user.email }}</td>
                <td>{{ user.country || user.aff_with }}</td>
                <td>{{ user.role }}</td>
                <td :class="statusClass(user)">{{ statusTxt(user) }}</td>
                <td><jet-nav-link :href="'/users/'+user.id" :active="route().current('dashboard')">View</jet-nav-link></td>
            </tr>
        </table>
        <div class="empty-user text-center mt-5" v-if="users < 1">
            <b>There were no users found</b>
        </div>
        <paginator :paginator="meta" v-on:pageclick="getUsers"/>

        <!-- Confirmation Modal -->
        <jet-dialog-modal :show="confirmUnlock" @close="toggleModal()">
            <template #content>
                {{ contentMsg }}
            </template>

            <template #footer>
                <jet-secondary-button @click="toggleModal()">
                    Cancel
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click="unlockUsers" :class="{ 'opacity-25': unlockingUsers }" :disabled="unlockingUsers">
                    Unlock
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
    </div>
</template>

<script>
import SubNav from './SubNav.vue';
import JetNavLink from '@/Jetstream/NavLink'
import Paginator from "./Paginator.vue";


import JetActionSection from '@/Jetstream/ActionSection';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';

export default {
    components: {
        SubNav,
        JetNavLink,
        Paginator,
        JetActionSection,
        JetDialogModal,
        JetDangerButton,
        JetInput,
        JetInputError,
        JetSecondaryButton,
    },
    data() {
        return {
            users: [],
            links: {},
            meta: {},
            searchText: '',
            selectedRole: '',
            selectedStatus: '',
            selectedCountry: '',
            queryString: '',
            action: '',
            checkedUsers: [],
            confirmUnlock: false,
            unlockingUsers: false,
        }
    },
    computed: {
        contentMsg() {
            return "Unlock users?";
        },
        isEmpty: ({ checkedUsers }) => checkedUsers.length === 0,
    },
    methods: {
        statusTxt(user) {
            if (user.is_approved === true) {
                if (user.is_locked) {
                    return 'Locked';
                } else {
                    return 'Active';
                }
            } else if (user.is_approved === false) {
                return 'Rejected';
            } else if (user.is_approved === null) {
                return 'Pending';
            } else {
                return 'Unknown';
            }
        },
        statusClass(user) {
            if (user.is_approved === true) {
                if (user.is_locked) {
                    return 'text-yellow-600';
                } else {
                    return 'text-green-600';
                }
            } else if (user.is_approved === false) {
                return 'text-red-600';
            } else if (user.is_approved === null) {
                return 'text-blue-600';
            } else {
                return 'text-gray-600';
            }
        },
        unlockClass(isEmpty) {
            if (isEmpty) {
                return 'bg-gray-500 hover:bg-gray-700 text-white mb-2 py-2 px-4 rounded';
            } else {
                return 'bg-blue-500 hover:bg-blue-700 text-white mb-2 py-2 px-4 rounded';
            }
        },
        userSearch: _.debounce(
            function() {
                // var searchParams = new URLSearchParams(this.queryString);
                // searchParams.set("search", this.searchText)
                var role = "";
                var status = "";
                var country = "";

                if (this.selectedRole) {
                    if (this.selectedRole != "All") {
                        role = '&role='+this.selectedRole;
                    }
                }

                if (this.selectedStatus) {
                    if (this.selectedStatus != "All") {
                        status = '&status='+this.selectedStatus;
                    }
                }

                if (this.selectedCountry) {
                    if (this.selectedCountry != "All") {
                        country = '&country='+this.selectedCountry;
                    }
                }

                this.getUsers('?search='+this.searchText+role+status+country);
        }, 500),
        getUsers(queryString) {
            if (queryString) {
                this.queryString = queryString;
                axios.get('/api/users'+this.queryString)
                    .then((res) => {
                        this.users = res.data.data;
                        this.links = res.data.links;
                        this.meta = res.data.meta;
                    })
            } else {
                axios.get('/api/users')
                    .then((res) => {
                        this.users = res.data.data;
                        this.links = res.data.links;
                        this.meta = res.data.meta;
                    })
            }
        },
        clearFilters() {
            this.searchText = '';
            this.selectedRole = '';
            this.selectedStatus = '';
            this.selectedCountry = '';
            this.getUsers();
        },
        toggleModal(action) {
            this.action = action;
            if (action) {
                this.confirmUnlock = true;
            } else {
                this.confirmUnlock = false;
            }
        },
        unlockUsers() {
            var _this = this;

            this.checkedUsers.forEach((userId) => {
                console.log(userId);
                axios.put('/api/users/'+userId, {action: 'unlockuser'})

            });

            _this.toggleModal();
            window.location.reload();
        }
    },
    mounted() {
        this.getUsers();
    },
};
</script>

<style scoped>
    #filter {
        height: 100%;
    }
    #myInput {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="%23666" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>'); /* CSS-only search icon */
        background-position: 10px 12px; /* Position the search icon */
        background-repeat: no-repeat; /* Do not repeat the icon image */
        width: 100%; /* Full-width */
        font-size: 16px; /* Increase font-size */
        padding: 12px 20px 12px 40px; /* Add some padding */
        border: 1px solid #ddd; /* Add a grey border */
        margin-bottom: 12px; /* Add some space below the input */
    }

    #myTable {
        border-collapse: collapse; /* Collapse borders */
        width: 100%; /* Full-width */
        border: 1px solid #ddd; /* Add a grey border */
        font-size: 18px; /* Increase font-size */
    }

    #myTable th, #myTable td {
        text-align: left; /* Left-align text */
        padding: 12px; /* Add padding */
    }

    #myTable tr {
        /* Add a bottom border to all table rows */
        border-bottom: 1px solid #ddd;
    }

    #myTable tr.header, #myTable tr:hover {
        /* Add a grey background color to the table header and on hover */
        background-color: #f1f1f1;
    }
</style>